import {List, Tag, Typography} from "antd";
import {Link} from "react-router-dom";
import {useEffect} from "react";

const KBListItem = ({ item }) => {
  return(
    <>
      {item.link === false ? item.name : <Link to={item.link ?? '/'}>{item.name}</Link>}
      {item.count ? <Tag>{item.count}</Tag> : ''}
    </>
  )
}

export const KBList = ({ data, loading }) => {

  return(
    <List
      loading={loading ?? false}
      header={<div style={{ textAlign: 'center' }}><Typography.Text strong>{data.name}</Typography.Text></div>}
      footer={false}
      bordered
      rowKey={r => r.name}
      dataSource={data.data}
      renderItem={item => (
        <List.Item>
          <KBListItem item={item} />
        </List.Item>
      )}
    />
  )
}